module.exports = __webpack_public_path__ + "static/img/color.bca6e6ca.png";